import React, { useState } from "react";
import { ModalThemMoi }  from "./ModalThemMoi";

const BtnThemMoi = ({ onReload }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleSaved = () => {
    setShow(false);
    if (onReload) onReload();
  };
  return (
    <>
      <button type="button" className="btn btn-border-new" onClick={handleShow}>
        <span>
          <img
            src="/app-assets/images/icon-them-moi-cam-do-v2.png"
            style={{ paddingBottom: "5px", marginRight: '6px' }}
            alt="Thêm mới"
          />
          Thêm mới
        </span>
      </button>
      {show && (
        <ModalThemMoi
          show={show}
          onHide={handleClose}
          item={null}
          onSaved={handleSaved}
        />
      )}
    </>
  );
};

export default BtnThemMoi;
